<div
  class="flex h-full min-h-0 min-w-0 flex-col [&>*:last-child]:flex [&>*:last-child]:flex-col [&>*:last-child]:flex-1 [&>*:last-child]:min-h-0 [&>*:last-child]:min-w-0"
>
  <router-outlet />
</div>
